export default {
  namespaced: true,
  icons_info: {
    interphone : 'Interphone',
    camera: 'Camera',
    dmp_zone24h: 'Zone 24h',
    dmp_area: 'Area',
    dmp_output: 'Output device',
    dmp_zone: 'Zone',
    button: 'Button',
    density_device: 'Fog device',
    panel: 'Panel',
    camera_ptz: 'PTZ Camera',
    sensor_default: 'Temperature sensor',
    sensor_3: 'Vibration sensor',
    sensor_10: 'Humidity sensor',
    sensor_11: 'Dry contact',
    sensor_13: 'Voltage',
    input: 'Input device'
  },
};
